import React, { useState, useEffect } from "react";
import {
  Box,
  VStack,
  Flex,
  Button,
  Heading,
  Grid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { CourseCard } from "./CourseCard";
import coursesData from "./coursesData";

const Courses = () => {
  const [selectedCourseType, setSelectedCourseType] = useState("Cambridge IGCSE");
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  const filteredCourses = coursesData.filter((course) => {
    const title = course.title.toLowerCase();
    const isALevel = title.startsWith("as") || title.startsWith("alevel");
    if (selectedCourseType === "Cambridge A-Level") {
      return isALevel;
    }
    return !isALevel;
  });

  return (
    <Box id="courses" py={{ base: 8, md: 16 }} px={{ base: 4, md: 18 }}>
      <VStack spacing={8} alignItems="center">
        <Flex
          direction="column"
          align="center"
          w={{ base: "100%", lg: "60%" }}
          gap="14px"
          mb="40px"
        >
          <Heading
            color="#021A04"
            fontSize={{ base: "24px", md: "32px" }}
            fontWeight="550"
            textAlign="center"
          >
            Our Available Courses
          </Heading>
          <Flex border="1px solid #D7D7D7" borderRadius="25px" p="4px">
            {["Cambridge IGCSE", "Cambridge A-Level"].map((type) => (
              <Button
                key={type}
                borderRadius="25px"
                bg={selectedCourseType === type ? "#0069CA" : "#fff"}
                color={selectedCourseType === type ? "#fff" : "#021A04"}
                fontSize="14px"
                fontWeight="400"
                px="20px"
                py="8px"
                onClick={() => setSelectedCourseType(type)}
              >
                {type}
              </Button>
            ))}
          </Flex>
        </Flex>

        <Grid
          templateColumns="repeat(auto-fit, minmax(280px, 1fr))"
          gap="20px"
          w="100%"
        >
          {filteredCourses.map((course) => (
            <Box
              key={course.id}
              cursor="pointer"
              onClick={() =>
                    navigate(
                   `/classroom/${encodeURIComponent(course.id)}`
                  )
              }
                
            >
             <CourseCard
                key={course.id}
                onClick={() =>
                  navigate(
                    `/classroom/${encodeURIComponent(course.id)}`
                  )
                }
                title={course.title}
                description={course.description}
                papers={course.papers}
            />
            </Box>
          ))}
        </Grid>
      </VStack>
    </Box>
  );
};

export default Courses;
